<template>
  <div class="card text-center shadow-sm  flex-fill"
       :class="{'card-green': isEnabled===true, 'card-grey': isEnabled!==true, 'card-pdf': embedPdf===true}">
    <div class="card-body align-content-center justify-content-center">
      <h6 class="card-title">
        <i :class="`bi ${icon}`"
           style="font-size: 1.75em;"></i>
        {{ cardTitle }}
      </h6>
      <!-- Define card content and behavior based on isEnabled Boolean. -->
      <p v-if="isEnabled===true"
         class="card-text small">
        {{ cardText }}
      </p>
      <p v-else
         class="card-text small">
        {{ $t('TopicCardComponent.availableSoon') }}
      </p>
      <button v-if="isEnabled===true && embedPdf===false"
              class="btn btn-green"
              @click="this.$router.push({ name: buttonLink });">
        <i class="bi bi-arrow-right-circle"></i>
        {{ this.buttonText }}
      </button>

      <a v-if="isEnabled===true && embedPdf===true && documentId!=='' && thumbnailId!==''"
         :href="`https://canalls.uni-hohenheim.de/backend/index.php/documents/${documentId}`">
        <img :src="`https://canalls.uni-hohenheim.de/backend/index.php/images/${thumbnailId}`"
             alt=""
             style="max-width: 225px;"
             class="w-100"/>
      </a>

    </div>
  </div>
</template>

<script>
import {useI18n} from "vue-i18n";

export default {
  props: {
    isEnabled: {
      type: Boolean,
      required: true,
    },
    cardTitle: {
      type: String,
      required: true,
    },
    cardText: {
      type: String,
      required: true
    },
    buttonLink: {
      type: String,
      required: true
    },
    buttonText: {
      type: String,
      required: false,
    },
    icon: {
      type: String,
      required: false,
      default: '',
    },
    embedPdf: {
      type: Boolean,
      required: false,
      default: false,
    },
    documentId: {
      type: String,
      required: false,
      default: '',
    },
    thumbnailId: {
      type: String,
      required: false,
      default: '',
    }
  },
  setup() {
    const {t, locale} = useI18n();
    return {t, locale};
  }
};
</script>